GatorSurvey.app.directive("gsStyler", GsStyler);

function GsStyler() {
    return {
        require: "?ngModel",
        restrict: "AE",
        scope: {
            model: "=ngModel",
            styleToId: "=?"
        },
        controller: function($scope, $rootScope) {
            $scope.$watch("model", function (newValue, oldValue) {
                var css = "#" + $scope.styleToId + " .bts-active {\r";
                var keys = Object.keys(newValue);
                for (var i = 0; i < keys.length; i++) {
                    css += "\t" + keys[i] + ":";
                    css += newValue[keys[i]] + " !important;\r";
                }
                css += "}";
                if ($scope.style.styleSheet) {
                    $scope.style.styleSheet.cssText = css;
                } else {
                    $scope.style.innerHTML = "";
                    $scope.style.innerHTML = css;
                }
            },true);
        },
        link: function($scope, elem, attrs) {            
            $scope.id = GatorSurvey.models.guid();

            var head = document.head || document.getElementsByTagName('head')[0],
                style = document.createElement('style'),
                css = "#" + $scope.styleToId + " .bts-active {\r";

            var keys = Object.keys($scope.model);
            for (var i = 0; i < keys.length; i++) {
                css += keys[i] + ":";
                css += $scope.model[keys[i]] + " !important;\r";
            }
            css += "}";
            style.id = $scope.id;
            style.type = 'text/css';
            if (style.styleSheet) {
                style.styleSheet.cssText = css;
            } else {
                style.innerHTML = css;
            }
            $scope.style = style;
            head.appendChild(style);
        }
    };
}